import { Virus, Response } from 'typings/entities/viruses';

export const viruses = ({ data }: { data: Response }): Response => data;

export const virus = ({ data }: { data: Virus }): Virus => data;
